import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Tracks which public bookings this device has already seen/acknowledged, so the
 * new-booking alarm rings once per booking and survives a page reload (it keeps
 * ringing after a refresh until someone acknowledges it). Per-device by design.
 */
interface BookingAlarmState {
  initialized: boolean;
  seenIds: string[];
  /** Mark these ids as seen (also used to baseline existing bookings on first load). */
  markSeen: (ids: string[]) => void;
  reset: () => void;
}

export const useBookingAlarmStore = create<BookingAlarmState>()(
  persist(
    (set) => ({
      initialized: false,
      seenIds: [],
      markSeen: (ids) =>
        set((s) => {
          const next = new Set(s.seenIds);
          for (const id of ids) next.add(id);
          return { seenIds: [...next].slice(-1000), initialized: true };
        }),
      reset: () => set({ initialized: false, seenIds: [] }),
    }),
    { name: 'bpc.bookingAlarm' },
  ),
);
